import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<{ id: number, name: string, status: string, updatedUTC: number }> {

	return {
		rowName: { singular: 'Team', plural: 'Teams' },
		getRowKey: row => '' + row.id,
		stateKey: 'accelerators-teams-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
		renderRowClasses: row => row.status == 'Active' ? [] : ['grid-cell-strikethrough', 'grid-cell-gray-text'],
	}
}
